<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
          <v-card class="elevation-12">
            <alarm-toolbar />
            <router-view></router-view>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import AlarmToolbar from "../components/alarm/AlarmToolbar.vue";

export default {
  name: "AlarmView",
  components: { AlarmToolbar },
};
</script>